import { DropDownSectionConsts, ItemTableConsts, MdmVendorStates } from 'client/util/Constants';
import { featureFlags } from 'client/store/modules/FeatureFlagsModule';
import SystemFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/SystemFilters';

const {
  selectOne,
} = DropDownSectionConsts;

const {
  internal,
  external,
  none,
} = MdmVendorStates;

const {
  android,
  darwin,
  ios,
  linux,
  windows,
} = ItemTableConsts.parentOSType;

export default {
  data() {
    const deviceStatusMenuItems = [
      {
        filter: SystemFilters.status(true),
        label: 'active',
        action: () => {
          this.handleDropDownAction(SystemFilters.status(true));
        },
      },
      {
        filter: SystemFilters.status(false),
        label: 'inactive',
        action: () => {
          this.handleDropDownAction(SystemFilters.status(false));
        },
      },
    ];
    const deviceOsMenuItems = [
      {
        filter: SystemFilters.osFamily(ios),
        label: 'iOS',
        action: () => {
          this.handleDropDownAction(SystemFilters.osFamily(ios));
        },
      },
      {
        filter: SystemFilters.osFamily(linux),
        label: 'Linux',
        action: () => {
          this.handleDropDownAction(SystemFilters.osFamily(linux));
        },
      },
      {
        filter: SystemFilters.osFamily(darwin),
        label: 'Mac',
        action: () => {
          this.handleDropDownAction(SystemFilters.osFamily(darwin));
        },
      },
      {
        filter: SystemFilters.osFamily(windows),
        label: 'Windows',
        action: () => {
          this.handleDropDownAction(SystemFilters.osFamily(windows));
        },
      },
    ];
    const diskEncryptionStatusMenuItems = [
      {
        filter: SystemFilters.fde(true),
        label: 'encrypted',
        action: () => {
          this.handleDropDownAction(SystemFilters.fde(true));
        },
      },
      {
        filter: SystemFilters.fde(false),
        label: 'unencrypted',
        action: () => {
          this.handleDropDownAction(SystemFilters.fde(false));
        },
      },
    ];
    const mdmStatusMenuItems = [
      {
        filter: SystemFilters.mdm(internal),
        label: 'enrolled with JumpCloud',
        action: () => {
          this.handleDropDownAction(SystemFilters.mdm(internal));
        },
      },
      {
        filter: SystemFilters.mdm(none),
        label: 'not enrolled',
        action: () => {
          this.handleDropDownAction(SystemFilters.mdm(none));
        },
      },
      {
        filter: SystemFilters.mdm(external),
        label: 'enrolled with another vendor',
        action: () => {
          this.handleDropDownAction(SystemFilters.mdm(external));
        },
      },
    ];
    if (this.$hasFeatureFlag(featureFlags.androidEmmMvp)) {
      deviceOsMenuItems.unshift(
        {
          filter: SystemFilters.osFamily(android),
          label: 'Android',
          action: () => {
            this.handleDropDownAction(SystemFilters.osFamily(android));
          },
        },
      );
    }
    const dropDownMenuSections = [
      {
        menuLabel: 'device status:',
        menuType: selectOne,
        menuItems: deviceStatusMenuItems,
      },
      {
        menuLabel: 'device OS:',
        menuType: selectOne,
        menuItems: deviceOsMenuItems,
      },
      {
        menuLabel: 'disk encryption status:',
        menuType: selectOne,
        menuItems: diskEncryptionStatusMenuItems,
      },
      {
        menuLabel: 'MDM status:',
        menuType: selectOne,
        menuItems: mdmStatusMenuItems,
      },
    ];

    return {
      dropDownMenuSections,
    };
  },
};
